import { defineStore } from "pinia";
import { Platform } from "quasar";

export const KlaviyoEventTypes = Object.freeze({
  VIEWED_CAMPAIGN: "Viewed Campaign",
  VIEWED_SWAG_ITEM: "Viewed Swag Item",
  VIEWED_COUPONS: "Viewed Coupons",
  VIEWED_BALANCE: "Viewed Balance",
  STORE_FEEDBACK: "Store Feedback",
});

export const useklaviyoEventsStores = defineStore("klaviyoEvents", {
  state: () => ({}),
  getters: {},
  actions: {
    async addKlaviyoEvent(params = {}) {
      try {
        params.device_type = Platform.is.mobile
          ? Platform.is.android
            ? "Android"
            : "iOS"
          : "Web";
        if (params.store_id) params.acc = params.store_id;
        await this.$request.post(this.apiEndpoints.KLAVIYO_EVENT, params);
      } catch (error) {
        console.error("Error adding Klaviyo event:", error);
      }
    },
  },
});
